import {GetCategoryQuery} from 'src/generated/graphql';

export const parseCategoryData = (
    categoryData: NonNullable<GetCategoryQuery['courseCategory']>,
    exceptionMessage: string,
) => {
    try {
        const url = new URL(categoryData.url);
        return {
            id: Number(categoryData.id),
            title: categoryData.name,
            absolute_url: `${url.pathname}${url.search}${url.hash}`,
            type: '',
            title_cleaned: '',
            icon_name: '',
            children: categoryData.subcategories.map((subcategory) => {
                const url = new URL(subcategory.url);
                return {
                    id: Number(subcategory.id),
                    absolute_url: `${url.pathname}${url.search}${url.hash}`,
                    title: subcategory.name,
                    type: '',
                    title_cleaned: '',
                    icon_name: '',
                };
            }),
        };
    } catch (error) {
        if ((error as Error)?.message?.includes('Invalid URL')) {
            throw new Error(exceptionMessage);
        }
        throw error;
    }
};
